import { selectMenuItems } from "@store/menuItem/menuItemReducer";
import { useAppSelector } from "@store/store";
import { FunctionComponent } from "react";

import "./OnboardingMenuItems.css";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

// x and y offsets for menu items that are vertically aligned, even indexes left offset and
// odd indexes right offset.
const OFFSETS = [76, 73, 40, 41, 74, 69, 58, 94];
const DISTANCE_BETWEEN_MENU_ITEMS_DESKTOP = 58;
const DISTANCE_BETWEEN_MENU_ITEMS_MOBILE = 38;

const OnboardingMenuItems: FunctionComponent = () => {
  const menuItems = useAppSelector(selectMenuItems);
  const { isMobile } = useWindowSize();
  const distanceBetweenMenuItems = isMobile
    ? DISTANCE_BETWEEN_MENU_ITEMS_MOBILE
    : DISTANCE_BETWEEN_MENU_ITEMS_DESKTOP;

  // Display up to 8 menu items total.
  const menuItemsToDisplay = menuItems.slice(0, 8);

  return (
    <div
      className="onboarding-menu-items-component"
      style={{
        height: `${
          menuItemsToDisplay.length * distanceBetweenMenuItems - 22
        }px`,
      }}>
      {menuItemsToDisplay.map((menuItem, index) => {
        return (
          <div
            key={menuItem.id}
            className="menu-item"
            style={{
              top: `${index * distanceBetweenMenuItems}px`,
              left: index % 2 === 0 ? `${OFFSETS[index]}px` : undefined,
              right: index % 2 === 1 ? `${OFFSETS[index]}px` : undefined,
            }}>
            <img src={menuItem.inactiveIconUrl} width={20} height={20} />
            <span className="label">{menuItem.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export { OnboardingMenuItems };
